// CPI-1241 (Vietnam only): was a booking created after the project's event date? The parsing and
// gating rules are in docs/merge-audit-main-svn-to-master.md, the CPI-1241 / CPI-1250 notes.

export function toInstant(value) {
  if (value === null || value === undefined || value === '') return null;
  if (value instanceof Date) {
    const fromDate = value.getTime();
    return Number.isNaN(fromDate) ? null : fromDate;
  }
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }
  if (typeof value !== 'string') return null;
  const parsed = Date.parse(value);
  return Number.isNaN(parsed) ? null : parsed;
}

export function isCreatedAfterEventDate(createdAt, eventDate, isEnabled = true) {
  if (!isEnabled) return false;
  const created = toInstant(createdAt);
  const event = toInstant(eventDate);
  if (created === null || event === null) return false;
  return created > event;
}

export function hasEventDateLapsed(eventDate, isEnabled = true, now = Date.now()) {
  return isCreatedAfterEventDate(now, eventDate, isEnabled);
}
